import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import { ActionFunctionArgs, Form, useNavigate, useParams } from "react-router-dom";
import { useGlobalAlert } from "../../hooks/useAlert";
import { api } from "../../services/api.service";
import { isAxiosError } from "../../utils/helpers";

export async function action({ request, params }: ActionFunctionArgs) {
  const formData = await request.formData();
  const data = Object.fromEntries(formData);

  try {
    await api.request({
      method: "POST",
      url: `/asset_retrievals/${params.retrievalId}/regenerate_labels`,
      data,
    });

    useGlobalAlert.alertSuccess("Label regeneration has been queued.");
    return null;
  } catch (error: unknown) {
    if (isAxiosError(error)) {
      const errorData = error.response?.data as { message?: string } | undefined;
      useGlobalAlert.alertError(
        `Could not regenerate labels. ${errorData?.message != null ? String(errorData.message) : error.message}`,
      );
    } else {
      useGlobalAlert.alertError(error instanceof Error ? error.message : "Something went wrong.");
    }
    return null;
  }
}

const reasonOptions = ["Lost or damaged box", "Submitted wrong box type", "Label expired"];

export function RegenerateLabelsAssetRetrievalDialog() {
  const params = useParams();
  const navigate = useNavigate();
  const handleDismiss = () => navigate(-1);

  return (
    <Dialog open onClose={handleDismiss} maxWidth="sm" fullWidth>
      <DialogTitle>Regenerate labels</DialogTitle>
      <DialogContent>
        <DialogContentText>Please select the label you want to regenerate, and select a reason.</DialogContentText>
        <Form
          action={`/asset_retrievals/${params.retrievalId}/regenerate-labels`}
          id="regenerate-labels-asset-retrieval-order-form"
          method="post"
          onSubmit={handleDismiss}
        >
          <Stack gap={1} marginTop={1}>
            <TextField select fullWidth required name="label" label="Label" size="small" defaultValue="">
              <MenuItem value="outbound">Outbound (To)</MenuItem>
              <MenuItem value="inbound">Inbound (Return)</MenuItem>
            </TextField>
            <Autocomplete
              freeSolo
              options={reasonOptions}
              renderInput={(inputParams) => (
                <TextField
                  {...inputParams}
                  fullWidth
                  required
                  name="reason"
                  label="Reason"
                  size="small"
                  defaultValue=""
                />
              )}
            />
          </Stack>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDismiss}>Back</Button>
        <Button type="submit" form="regenerate-labels-asset-retrieval-order-form">
          Regenerate labels
        </Button>
      </DialogActions>
    </Dialog>
  );
}
